/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_App_Anna_Quote_P2Inputs */

const en_marketing_app_anna_quote_p2 = /** @type {(inputs: Marketing_App_Anna_Quote_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Even at 1.5x speed, it was engaging to listen to. It's a game changer to be able to listen while walking!`)
};

const es_marketing_app_anna_quote_p2 = /** @type {(inputs: Marketing_App_Anna_Quote_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Incluso a velocidad 1.5x, era atractiva para escuchar. ¡Es un cambio total poder escuchar mientras caminas!`)
};

/**
* | output |
* | --- |
* | "Even at 1.5x speed, it was engaging to listen to. It's a game changer to be able to listen while walking!" |
*
* @param {Marketing_App_Anna_Quote_P2Inputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const marketing_app_anna_quote_p2 = /** @type {((inputs?: Marketing_App_Anna_Quote_P2Inputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_App_Anna_Quote_P2Inputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_marketing_app_anna_quote_p2(inputs)
	return en_marketing_app_anna_quote_p2(inputs)
});